import Footer from "./Footer";
import Navbar from "./Navbar";
import SEO from "./SEO";

const TermsConditions: React.FC = () => {
  const termsSections = [
    {
      title: "1. Introduction",
      content:
        `${import.meta.env.VITE_COMPANY_NAME} provides personal loans to salaried individuals under the regulatory oversight of ${import.meta.env.VITE_COMPANY_NBFC} Our goal is to offer instant, easy, and transparent financial solutions.`,
    },
    {
      title: "2. Eligibility Criteria",
      content:
        "To apply for a personal loan, you must meet the following requirements:",
      list: [
        "Be at least 21 years old and not older than 60 at the time of application.",
        "Be a salaried individual with stable income from a recognized organization.",
        `Meet the minimum monthly income criteria defined by ${import.meta.env.VITE_COMPANY_NBFC}`,
        "Be a resident of India with a satisfactory credit score and financial history.",
      ],
    },
    {
      title: "3. Loan Application Process",
      content:
        `The process includes registration, application form, document submission, and credit assessment. Approval is solely at the discretion of ${import.meta.env.VITE_COMPANY_NBFC}`,
    },
    {
      title: "4. Loan Terms",
      content:
        "Loan amount, interest rate, and repayment schedule are determined based on applicant profile. Interest rate remains fixed during the tenure.",
    },
    {
      title: "5. Fees and Charges",
      content:
        "Applicable fees may include processing fee, late payment charges, Early repayment may attract prepayment penalties, etc., as mentioned in the loan agreement.",
    },
    {
      title: "6. Loan Disbursement",
      content:
        `Once approved and formalities completed, the loan amount will be credited to your bank account. Disbursement timelines may vary, but ${import.meta.env.VITE_COMPANY_NAME} strives for quick processing.`,
    },
    {
      title: "7. Loan Repayment",
      content:
        "Repayments must follow the schedule outlined in the loan agreement. Payments may be auto-debited via NACH or through digital methods such as UPI. Early repayment may attract foreclosure charges.",
    },
    {
      title: "8. Default and Consequences",
      content:
        "Failure to repay on time may lead to late fees, negative reporting to credit bureaus, and possible legal action.",
    },
    {
      title: "9. Cancellation of Loan",
      content:
        "Applications may be cancelled before disbursement. Once disbursed, cancellation is not possible. Prepayment is allowed as per agreement terms.",
    },
    {
      title: "10. Data Privacy and Security",
      content:
        "All information is handled securely in compliance with data protection laws and used only for loan processing and communication.",
    },
    {
      title: "11. User Responsibilities",
      content:
        "You must provide accurate details during registration and application. Misrepresentation may lead to denial of service or legal action.",
    },
    {
      title: "12. Amendments to Terms",
      content:
        "We may update these terms anytime. Updates will be posted on our website, and it is your responsibility to stay informed.",
    },
    {
      title: "13. Dispute Resolution",
      content:
        "Disputes will first be attempted to resolve amicably. If unresolved, they fall under the jurisdiction of courts in Delhi, India.",
    },
    {
      title: "14. Limitation of Liability",
      content:
        `${import.meta.env.VITE_COMPANY_NBFC} is not liable for any loss, damage, or inconvenience arising from the use of this website or services, except as expressly mentioned in the loan agreement.`,
    },
    {
      title: "15. Governing Law",
      content:
        "These Terms and Conditions are governed by and construed in accordance with the laws of India.",
    },
  ];

  return (
    <div className="min-h-screen bg-white text-text-primary font-mono selection:bg-secondary selection:text-white ">
      <SEO
        title="Terms & Conditions"
        description={`Official institutional agreement for ${import.meta.env.VITE_COMPANY_NAME}. Execution of services acknowledges all clauses for digital lending and loan protocols.`}
        keywords={`loan terms, personal loan agreement, ${import.meta.env.VITE_COMPANY_NAME} policies`}
      />
      <Navbar />


      {/* Official Registry Hero */}
      <section className="w-full bg-text-primary py-32 md:py-48 text-center px-6 relative overflow-hidden border-b-8 border-secondary mb-24">
        <div className="absolute inset-0 opacity-[0.05] pointer-events-none"
          style={{ backgroundImage: `linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)`, backgroundSize: '40px 40px' }} />

        <div className="relative z-10 max-w-5xl mx-auto">
          <div className="inline-flex items-center gap-4 px-6 py-2 bg-white/5 border border-white/10 text-secondary text-[10px] font-black uppercase tracking-[0.5em] mb-12">
            <div className="w-2 h-2 bg-secondary animate-pulse" />
            Terms_Archive_Protocol_v8.2
          </div>
          <h1 className="text-5xl md:text-[6rem] font-black tracking-tighter leading-[0.85] mb-12 uppercase text-white italic">
            Terms <span className="text-secondary not-italic">& Conditions.</span>
          </h1>
          <p className="text-white/60 text-lg md:text-2xl max-w-3xl mx-auto font-bold leading-relaxed border-y border-white/10 py-10 uppercase tracking-tight">
            Institutional agreement for terminal usage. <br />
            <span className="text-white">Execution of services acknowledges all clauses below.</span>
          </p>
        </div>
      </section>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 pb-40">
        <div className="border-t-4 border-text-primary">
          {termsSections.map((section, idx) => (
            <div key={idx} className="border-b border-text-primary/10 py-16 group">
              <div className="flex flex-col gap-10">
                <div className="flex items-start gap-8">
                  <span className="text-secondary font-black text-xs pt-1">CLAUSE_{idx + 1 < 10 ? `0${idx + 1}` : idx + 1}</span>
                  <h2 className="text-3xl md:text-5xl font-black text-text-primary leading-tight uppercase tracking-tighter italic">
                    {section.title.includes('.') ? section.title.split('. ')[1] : section.title}
                  </h2>
                </div>

                <div className="pl-16 md:pl-24 space-y-8">
                  {section.content && (
                    <p className="text-text-secondary font-bold text-lg leading-relaxed uppercase tracking-tight border-l-4 border-text-primary/5 pl-8 italic">
                      {section.content}
                    </p>
                  )}
                  {section.list && (
                    <ul className="space-y-6">
                      {section.list.map((li, i) => (
                        <li key={i} className="flex items-start gap-4 text-text-primary font-bold text-base leading-relaxed">
                          <div className="w-2 h-2 bg-secondary mt-2 shrink-0" />
                          <span className="uppercase tracking-tight">{li}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsConditions;
